import { AxiosError } from 'axios'

import { Queries } from 'api/queries.enum'
import {
    GetPulseSurveysTemplatesParams,
    GetPulseSurveysTemplatesResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { getPulseSurveysTemplates } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { useQuery } from 'hooks/useQuery'

export const useGetPulseSurveysTemplates = (params?: GetPulseSurveysTemplatesParams) => {
    return useQuery<GetPulseSurveysTemplatesResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveysTemplates, params],
        queryFn: () => getPulseSurveysTemplates(params),
        ...preventRefetchQueryOptions,
    })
}
